export enum BRAND {
    TOPDANMARK = 'TD'
}

export enum PRODUCTKEY {
    REJSE = 'TRAVEL'
}

export enum PRODUCTKEYDK {
    REJSE = 'Rejse'
}

export enum PREMIUMRATE {
    MONTHLY = 12,
    YEARLY = 1
}

export enum PACKAGE_NAME {
    PREMIUM = 'PREMIUM',
    STANDARD = 'STANDARD',
    BASIS = 'BASIS'
}

export enum TERMINATION_WHEN {
    QUICK = 'QUICK', // as soon as possible
    MPD = 'MPD' // Main Payment Day(årsdag)
}

export const MIN_AGE = 18;
export const MAX_AGE = 99;

export interface ICreatePackage {
    brand: BRAND;
    productKey: PRODUCTKEY;
    householdSize: number;
}

export interface IUpdatePackage {
    brand: BRAND;
    productKey: PRODUCTKEY;
    quoteIds: number[];
    deductible: number;
    additionalCoverage: {
        coverageAlias: string;
        selected: boolean;
    };
}

export interface ICoverageList {
    coverageId: number;
    coverageAlias: string;
    name: string;
    selected: boolean;
    deductableBasis: number;
    deductableAmount: number;
    showInPackage?: boolean;
}

export interface ICreatePackageDetails {
    defaultSelected: boolean;
    packageName: PACKAGE_NAME;
    quoteId: number;
    coverages: ICoverageList[];
}

export interface ICreatePackageResponse {
    brand: BRAND;
    productKey: PRODUCTKEY;
    deductibles: any[];
    packages: Array<ICreatePackageDetails>;
    additionalCoverages: Array<string>;
}

// Package screen
export interface IPackageDetailsListType {
    packageName: PACKAGE_NAME;
    quoteId: number;
    productId: number;
    additionalCoverages: Array<string>; // additional(possible) coverages that may be selected/unselected
    coverages: Array<ICoverageList>;
    monthlyPrice?: number;
    yearlyPrice?: number;
}

export interface IPackageDetails {
    brand: BRAND;
    productKey: PRODUCTKEY;
    additionalCoverages: Array<string>; // additional(possible) coverages that may be selected/unselected
    packages: IPackageDetailsListType[];
}

export interface IAddressInfo {
    zipCode: null | string;
    streetName: null | string;
    houseNumber: null | string;
    postalCodeName: null | string;
    supCityName: null | string;
    floor: null | string;
    door: null | string;
}

export interface IAddress {
    address: null | string;
    addressInfo: IAddressInfo;
    status: null | string;
    event: null | string;
    kvhxUrl: null | string;
}

export enum EMAIL_IDENTIFIER {
    TRAVEL_CALLME = 'TRAVEL_CALLME',
    TRAVEL_SALES_COMPLETE = 'TRAVEL_SALES_COMPLETE',
    GENERAL_CALLME = 'GENERAL_CALLME'
}

export enum EMAIL_EVENT {
    NO_EXISTING_CONTENT = 'NO_EXISTING_CONTENT',
    SALES_COMPLETE = 'SALES_COMPLETE',
    GENERAL_ERROR = 'GENERAL_ERROR',
    STUDENT_INSURANCE = 'STUDENT_INSURANCE',
    INSISTS_NO_EXISTING_CONTENT = 'INSISTS_NO_EXISTING_CONTENT',
    HAS_EXISTING_TRAVEL = 'HAS_EXISTING_TRAVEL',
    INSURANCE_ACTIVATED = 'INSURANCE_ACTIVATED',
    AGE_NOT_VALID = 'AGE_NOT_VALID',
    INSISTS_NOT_LOGGED_IN = 'INSISTS_NOT_LOGGED_IN'
}

export interface IGeneralCallMeEmailTemplate {
    identifier: EMAIL_IDENTIFIER;
    event: EMAIL_EVENT;
    phoneNumber: string;
    fullName: string;
    productName?: PRODUCTKEYDK;
}

export interface ISalesCompleteEmail {
    identifier: EMAIL_IDENTIFIER;
    event: EMAIL_EVENT;
    quoteId: number;
    customerId: string;
    cprNumber: string;
    fullName: string;
    residentialAddress: string;
    phoneNumber: string;
    emailAddress: string;
    premiumRateDescription: string;
    packageName: PACKAGE_NAME;
    effectiveDate?: string;
    bankRegistrationNumber?: string;
    bankAccountNumber?: string;
    currentInsuranceCompany?: string;
    eboks: boolean;
    householdSize: number;
}

export interface IBuyInsurance {
    productKey: PRODUCTKEY;
    brand: BRAND;
    quoteId: number;
    emailAddress: string;
    productId: number;
    premiumRate: PREMIUMRATE;
    bankRegistrationNumber?: string;
    bankAccountNumber?: string;
    accept: boolean;
    effectiveDate?: string;
    eboks: boolean;
    packageName?: string;
}

export interface IStakeHolder {
    fullName: string; // Added by FE code
    firstName: string;
    lastName: string;
    cprNo: string;
    customerId: string;
    emailAddress: string;
    emailPriority: number;
    mobilePhone: string;
    streetAddress: string;
    zipCity: string;
    village: string;
    country: string;
    fullAddress: string; // Added by FE code
}
